import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TemplateAccessStep } from '../../../../agility-risk.enum';

@Component({
  selector: 'lib-access-manager-steps',
  templateUrl: './access-manager-steps.component.html',
  styleUrls: ['./access-manager-steps.component.scss']
})
export class AccessManagerStepsComponent implements OnInit {
  @Input() activeIndex: number = 0;
  @Input() totalSteps: number = 0;
  @Input() isNextDisabled: boolean = false;
  @Output() previous: EventEmitter<any> = new EventEmitter<any>();
  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() done: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }
}
